import { render, staticRenderFns } from "./HorizontalLayout.vue?vue&type=template&id=141061c4&scoped=true"
import script from "./HorizontalLayout.vue?vue&type=script&lang=js"
export * from "./HorizontalLayout.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLayout.vue?vue&type=style&index=0&id=141061c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../routestatus/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141061c4",
  null
  
)

export default component.exports